import React, { Component } from 'react';
import { View, Text } from 'react-native';

import PropTypes from 'prop-types';

import styles from './Video.Styles';

class Time extends Component {
  getTime(time) {
    const secs = time % 60;
    const s2 = (time - secs) / 60;
    const mins = s2 % 60;
    const hrs = (s2 - mins) / 60;
    const hours = this.addZeros(hrs) > 0 ? `${this.addZeros(hrs)}:` : '';
    return `${hours}${this.addZeros(mins)}:${this.addZeros(secs)}`;
  }

  addZeros = time => {
    return time < 10 ? `0${time}` : time;
  };

  render() {
    return (
      <View style={styles.timeContainer}>
        <Text style={styles.textColor}>{this.getTime(parseInt(this.props.time, 10))}</Text>
      </View>
    );
  }
}

Time.propTypes = {
  time: PropTypes.number.isRequired,
};

export default Time;
